import { RegistrationFlow } from '@/hooks/use-registration-context/types';
import { getUtcDateForMDY, yearsAgo } from '@/utils/date-time';
import {
    PropAgeGender,
    PropAgeGenderAgeRangeEnum,
    PropAgeGenderGenderEnum,
    PropSourceSourceEnum,
} from '@calm/evexia-analytics';
import { AccountAccount, AccountGender } from '@calm/evexia-web-sdk';

export function ageToAnalyticsAgeRange(
    age: Date | number
): PropAgeGenderAgeRangeEnum | undefined {
    if (!age) {
        return undefined;
    }
    const years = typeof age === 'number' ? age : yearsAgo(age);
    if (years < 13) {
        return undefined;
    } else if (years < 18) {
        return '13-17';
    } else if (years < 24) {
        return '18-23';
    } else if (years < 50) {
        return '24-49';
    } else if (years < 65) {
        return '50-64';
    } else {
        return '65+';
    }
}

export function genderToAnalyticsGender(
    gender?: AccountGender
): PropAgeGenderGenderEnum | undefined {
    if (!gender) {
        return undefined;
    }
    switch (gender) {
        case AccountGender.Female:
            return PropAgeGenderGenderEnum.Female;
        case AccountGender.Male:
            return PropAgeGenderGenderEnum.Male;
        case AccountGender.Genderqueer:
            return PropAgeGenderGenderEnum.Genderqueer;
        case AccountGender.NonBinary:
            return PropAgeGenderGenderEnum.Nonbinary;
        case AccountGender.TransgenderFemale:
            return PropAgeGenderGenderEnum.TransWoman;
        case AccountGender.TransgenderMale:
            return PropAgeGenderGenderEnum.TransMan;
        case AccountGender.PreferNotToSay:
            return PropAgeGenderGenderEnum.PreferNotToSay;
        case AccountGender.Other:
            return PropAgeGenderGenderEnum.Other;
        default:
            return undefined;
    }
}

export function accountToAgeGenderAnalytics(
    account: AccountAccount
): PropAgeGender {
    return {
        AgeRange: account?.dob
            ? ageToAnalyticsAgeRange(getUtcDateForMDY(account.dob))
            : undefined,
        Gender: genderToAnalyticsGender(account?.gender),
    };
}

export function registrationFlowToAnalyticsSource(
    registrationFlow: RegistrationFlow
): PropSourceSourceEnum | undefined {
    if (
        [
            RegistrationFlow.NewRegistration,
            RegistrationFlow.SkipSponsorship,
            RegistrationFlow.NewInviteeRegistration,
        ].includes(registrationFlow)
    ) {
        return PropSourceSourceEnum.RegistrationFlow;
    } else if (
        [
            RegistrationFlow.ChangeOfSponsorship,
            RegistrationFlow.ChangeOfInviteeSponsorship,
            RegistrationFlow.ExistingInviteeRegistration,
        ].includes(registrationFlow)
    ) {
        return PropSourceSourceEnum.UpdateSponsorship;
    } else if (
        [RegistrationFlow.ExistingRegistration].includes(registrationFlow)
    ) {
        return PropSourceSourceEnum.UpdateSponsorship;
    } else {
        return undefined;
    }
}
